// extracted by mini-css-extract-plugin
export var container = "style-module--container--7f92c";
export var crossed = "style-module--crossed--43f70";
export var form = "style-module--form--65bdf";
export var formWrap = "style-module--form-wrap--9cd4b";
export var hours = "style-module--hours--46380";
export var info = "style-module--info--878c9";
export var minutes = "style-module--minutes--286a4";
export var policy = "style-module--policy--3759e";
export var price = "style-module--price--3a82a";
export var priceWrap = "style-module--price-wrap--bc777";
export var reg = "style-module--reg--46ce7";
export var sub = "style-module--sub--19a23";
export var timer = "style-module--timer--1d74e";
export var widget = "style-module--widget--9e1fa";